import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepSetting extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Setting: Resource Representations</h1>
				<h2>Store Shipping Method</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> method_id </td>
							<td> Integer </td>
							<td> Shipping method id </td>
							<td> </td>
						</tr>
						<tr>
							<td> name </td>
							<td> String </td>
							<td> Display name for shipping method </td>
							<td> </td>
						</tr>
						<tr>
							<td> note </td>
							<td> String </td>
							<td> A description of the shipping method that can be displayed to buyers </td>
							<td> </td>
						</tr>
						<tr>
							<td> insurance </td>
							<td> Boolean </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> is_default </td>
							<td> Boolean </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> area </td>
							<td> String </td>
							<td> <br/>I: international<br/>D: domestic <br/>B: both </td>
							<td> </td>
						</tr>
						<tr>
							<td> is_available </td>
							<td> String </td>
							<td> </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
			</section>
		);
	}
}